var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanGuid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.82,
    height: 84.106,
    viewBox: "0 0 80.82 84.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10894",
    "data-name": "Group 10894",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10902",
    "data-name": "Group 10902",
    transform: "translate(10 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16017",
    "data-name": "Path 16017",
    d: "M90.583,81.4,80.207,63.2l3.1-23.47a6.9,6.9,0,0,0-2.243-6.3l-14-13.186a1.807,1.807,0,0,0-2.361-.1V5.421A5.427,5.427,0,0,0,59.281,0H23.8a5.427,5.427,0,0,0-5.421,5.421v9.857A6,6,0,0,0,10,20.78v2.3a5.976,5.976,0,0,0,1.71,4.189A5.976,5.976,0,0,0,10,31.457v2.3a5.976,5.976,0,0,0,1.71,4.189A5.976,5.976,0,0,0,10,42.135v2.3a5.976,5.976,0,0,0,1.71,4.189A5.976,5.976,0,0,0,10,52.812v2.3a6,6,0,0,0,8.378,5.5v9.857A5.427,5.427,0,0,0,23.8,75.892H40.489l4.161,7.3a1.807,1.807,0,1,0,3.14-1.79l-3.141-5.512H59.28A5.427,5.427,0,0,0,64.7,70.471V48.822a10.4,10.4,0,0,1,5.261-4.2A1.806,1.806,0,0,0,71.049,43.4l.821-3.145a1.807,1.807,0,0,0-.47-1.734l-4.3-4.3A8.055,8.055,0,0,1,66,24.206L78.589,36.061a3.3,3.3,0,0,1,1.137,3.193L76.544,63.327a1.808,1.808,0,0,0,.222,1.132L87.443,83.193a1.807,1.807,0,0,0,3.14-1.789ZM16,46.816h-.013a2.385,2.385,0,0,1-2.369-2.382v-2.3a2.385,2.385,0,0,1,2.369-2.382h.026a2.385,2.385,0,0,1,2.369,2.382v2.3a2.385,2.385,0,0,1-2.369,2.382ZM13.614,33.757v-2.3a2.385,2.385,0,0,1,2.369-2.382h.026a2.385,2.385,0,0,1,2.369,2.382v2.3a2.385,2.385,0,0,1-2.369,2.382h-.026A2.385,2.385,0,0,1,13.614,33.757Zm0-12.977a2.382,2.382,0,1,1,4.764,0v2.3a2.385,2.385,0,0,1-2.369,2.382h-.026a2.385,2.385,0,0,1-2.369-2.382ZM16,57.494a2.385,2.385,0,0,1-2.382-2.382v-2.3a2.385,2.385,0,0,1,2.369-2.382h.026a2.385,2.385,0,0,1,2.369,2.382v2.3A2.385,2.385,0,0,1,16,57.494ZM61.087,70.471a1.809,1.809,0,0,1-1.807,1.807H23.8a1.809,1.809,0,0,1-1.807-1.807V5.421A1.809,1.809,0,0,1,23.8,3.614H59.28a1.809,1.809,0,0,1,1.807,1.807Zm7.025-30.128-.335,1.284A14.892,14.892,0,0,0,64.7,43.485V36.93Z",
    transform: "translate(-10 0)",
    fill: "#84b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16018",
    "data-name": "Path 16018",
    d: "M170.807,47.615h7.228a1.807,1.807,0,0,0,0-3.614h-7.228a1.807,1.807,0,0,0,0,3.614Z",
    transform: "translate(-142.881 -36.773)",
    fill: "#84b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16019",
    "data-name": "Path 16019",
    d: "M189.431,396h-1.643a1.807,1.807,0,1,0,0,3.614h1.643a1.807,1.807,0,0,0,0-3.614Z",
    transform: "translate(-157.073 -330.95)",
    fill: "#84b5e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10907",
    "data-name": "Group 10907",
    transform: "translate(27.708 23.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10903",
    "data-name": "Group 10903",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16021",
    "data-name": "Path 16021",
    d: "M106.807,128.378A1.807,1.807,0,0,1,105,126.571v-4.764A1.807,1.807,0,0,1,106.807,120h4.764a1.807,1.807,0,0,1,0,3.614h-2.957v2.957A1.807,1.807,0,0,1,106.807,128.378Z",
    transform: "translate(-105 -120)",
    fill: "#4c36e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10904",
    "data-name": "Group 10904",
    transform: "translate(19.986 21.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M254.571,299.379h-4.764a1.807,1.807,0,0,1,0-3.614h2.957v-2.957a1.807,1.807,0,1,1,3.614,0v4.764A1.807,1.807,0,0,1,254.571,299.379Z",
    transform: "translate(-248 -291.001)",
    fill: "#4c36e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10905",
    "data-name": "Group 10905",
    transform: "translate(19.986 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M254.571,128.378a1.807,1.807,0,0,1-1.807-1.807v-2.957h-2.957a1.807,1.807,0,0,1,0-3.614h4.764a1.807,1.807,0,0,1,1.807,1.807v4.764A1.807,1.807,0,0,1,254.571,128.378Z",
    transform: "translate(-248 -120)",
    fill: "#4c36e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10906",
    "data-name": "Group 10906",
    transform: "translate(0 21.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M111.571,299.379h-4.764A1.807,1.807,0,0,1,105,297.572v-4.764a1.807,1.807,0,0,1,3.614,0v2.957h2.957a1.807,1.807,0,0,1,0,3.614Z",
    transform: "translate(-105 -291.001)",
    fill: "#4c36e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanGuid);
export default __webpack_public_path__ + "static/media/ScanGuid.fe114e6021e44fc9c0e3ffcb728d6eeb.svg";
export { ForwardRef as ReactComponent };